import { Icon } from 'core-ui';
import { CustomIconComponentProps } from 'src/models/icon';
import { ListProperySvg } from './svg';

export const ListProperyIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={ListProperySvg} {...props} />
);
